import 'react-datepicker/dist/react-datepicker.css';
import MultiStepForm from '../../components/wizard/multiStepForm';
import ClassDetails from './classDetails';
import UserDetails from './userDetails';
import { openNotification } from "../../components/notifications";
import { scheduleCourtesy } from '../../apis/sessionsApi';
import Messages from '../../utils/Messages';

const ScheduleCourtesy = ({ onSuccess }) => {
  const userLanguage = navigator.language || navigator.userLanguage;

  const steps = [
    { title: "Clase", component: ClassDetails },
    { title: "Usuario", component: UserDetails },
  ];

  const onSubmit = async (formData) => {
    const result = await scheduleCourtesy(formData);
    if (result.success) {
      openNotification(
        "success",
        "Clase agendada exitosamente",
        "Tu clase de cortesía ha sido agendada exitosamente. Puedes ingresar con tu correo clave 1234"
      );
      if (onSuccess) onSuccess();
    } else {
      const messageCode = result.error.response?.data?.responseCode || "UNKNOWN_ERROR";
      openNotification(
        "error",
        "Error al agenar la cortesía",
        Messages.getMessage(messageCode, userLanguage) || "Hubo un problema al intentar agendar tu cortesía. Por favor, inténtalo de nuevo."
      );
    }
  }

  return (
    <MultiStepForm steps={steps} onSubmit={onSubmit} />
  );
}

export default ScheduleCourtesy;
